$('.JStoggle-btn').on('click', function(){
	$(this).closest('div').find('.JStoggle-content').toggleClass('d-none'); 
});

// RESPONSIVE NAVIGATON
const nav = document.querySelector('#responsive-nav');
const btn = document.querySelector('.resp-nav-btn');
const closeBtn = document.querySelector('.JSclose-nav');

if (nav) {
    const mobileNavTabs = nav.querySelectorAll('[data-mobile-nav-tab]');

    mobileNavTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
            const panel = tab.dataset.mobileNavTab;
            nav.dataset.mobileNav = panel;

            mobileNavTabs.forEach((item) => {
                const isActive = item === tab;
                item.classList.toggle('is-active', isActive);
                item.setAttribute('aria-selected', String(isActive));
            });
        });
    });

    nav.dataset.mobileNav = nav.querySelector('.mobile-nav-panel-categories')
        ? 'categories'
        : 'pages';
}

function setupResponsiveNav(isMobile) {
    if (isMobile) {
        nav.setAttribute('popover', '');
        btn.setAttribute('commandFor', 'responsive-nav');
        btn.setAttribute('command', 'toggle-popover');
        closeBtn.setAttribute('commandFor', 'responsive-nav');
        closeBtn.setAttribute('command', 'hide-popover');
    } else {
        nav.removeAttribute('popover');
        btn.removeAttribute('commandFor');
        btn.removeAttribute('command');
        closeBtn.removeAttribute('commandFor');
        closeBtn.removeAttribute('command');
    }
}

const mq = window.matchMedia('(max-width: 991.98px)');
setupResponsiveNav(mq.matches);
mq.addEventListener('change', (e) => setupResponsiveNav(e.matches));

// SCROLL TO TOP 
var $scrollTopBtn = $('.JSscroll-top');
var isScrollTopVisible = false;
var rafScheduled = false;

function applyScrollTopVisibility() {
	var scrollTop = window.scrollY || window.pageYOffset;
	var shouldShow = scrollTop > 150;

	if (shouldShow !== isScrollTopVisible) {
		isScrollTopVisible = shouldShow;
		$scrollTopBtn.toggleClass('JSvisible', shouldShow);
	}

	rafScheduled = false;
}

$(window).on('scroll', function () {
	if (!rafScheduled) {
		rafScheduled = true;
		requestAnimationFrame(applyScrollTopVisibility);
	}
});

applyScrollTopVisibility();

if ($scrollTopBtn.length) {
	$scrollTopBtn.on('click', function () {
		document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
	});
}
